import { render } from "./Students.vue?vue&type=template&id=54cf7a0a&scoped=true"
import script from "./Students.vue?vue&type=script&lang=js"
export * from "./Students.vue?vue&type=script&lang=js"

import "./Students.vue?vue&type=style&index=0&id=54cf7a0a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54cf7a0a"]])

export default __exports__